(() => {
  function initStoryCarousel(root) {
    if (!root) return;

    if (root.dataset.carouselInitialized === 'true') {
      return;
    }

    root.dataset.carouselInitialized = 'true';

    const viewport = root.querySelector('[data-carousel-viewport]');
    const allSlides = Array.from(
      root.querySelectorAll('[data-carousel-slide]')
    );

    const slides = allSlides.filter(
      (slide) => slide.dataset.hasImage === 'true'
    );

    const controls = root.querySelector('[data-carousel-controls]');
    const prevButton = root.querySelector('[data-carousel-prev]');
    const nextButton = root.querySelector('[data-carousel-next]');

    const currentDisplay = root.querySelector(
      '[data-carousel-current]'
    );

    const totalDisplay = root.querySelector(
      '[data-carousel-total]'
    );

    if (!viewport) return;

    if (!slides.length) {
      if (controls) {
        controls.hidden = true;
      }

      return;
    }

    let currentIndex = 0;

    let startX = 0;
    let startY = 0;
    let isTouching = false;

    const normalize = (index) => {
      return (index + slides.length) % slides.length;
    };

    const formatNumber = (number) => {
      return String(number).padStart(2, '0');
    };

    const clearStates = () => {
      allSlides.forEach((slide) => {
        slide.classList.remove(
          'is-left',
          'is-center',
          'is-right'
        );

        slide.style.visibility = 'hidden';
        slide.style.opacity = '0';

        slide.setAttribute(
          'aria-hidden',
          'true'
        );
      });
    };

    const updateCounter = () => {
      if (currentDisplay) {
        currentDisplay.textContent =
          formatNumber(currentIndex + 1);
      }

      if (totalDisplay) {
        totalDisplay.textContent =
          formatNumber(slides.length);
      }
    };

    const update = () => {
      clearStates();
      updateCounter();

      /* 画像1枚 */
      if (slides.length === 1) {
        const center = slides[0];

        center.classList.add('is-center');

        center.style.visibility = 'visible';
        center.style.opacity = '1';

        center.setAttribute(
          'aria-hidden',
          'false'
        );

        if (controls) {
          controls.hidden = true;
        }

        return;
      }

      if (controls) {
        controls.hidden = false;
      }

      /* 画像2枚 */
      if (slides.length === 2) {
        const center = slides[currentIndex];

        const right =
          slides[
            normalize(currentIndex + 1)
          ];

        center.classList.add('is-center');

        center.style.visibility = 'visible';
        center.style.opacity = '1';

        center.setAttribute(
          'aria-hidden',
          'false'
        );

        right.classList.add('is-right');

        right.style.visibility = 'visible';
        right.style.opacity = '0.7';

        right.setAttribute(
          'aria-hidden',
          'false'
        );

        return;
      }

      /* 画像3枚 */
      const previous =
        slides[
          normalize(currentIndex - 1)
        ];

      const center =
        slides[currentIndex];

      const next =
        slides[
          normalize(currentIndex + 1)
        ];

      previous.classList.add('is-left');

      previous.style.visibility = 'visible';
      previous.style.opacity = '0.7';

      previous.setAttribute(
        'aria-hidden',
        'false'
      );

      center.classList.add('is-center');

      center.style.visibility = 'visible';
      center.style.opacity = '1';

      center.setAttribute(
        'aria-hidden',
        'false'
      );

      next.classList.add('is-right');

      next.style.visibility = 'visible';
      next.style.opacity = '0.7';

      next.setAttribute(
        'aria-hidden',
        'false'
      );
    };

    const goPrevious = () => {
      currentIndex =
        normalize(currentIndex - 1);

      update();
    };

    const goNext = () => {
      currentIndex =
        normalize(currentIndex + 1);

      update();
    };

    /* ========================================
       BUTTON
    ======================================== */

    if (prevButton) {
      prevButton.addEventListener(
        'click',
        goPrevious
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        'click',
        goNext
      );
    }

    /* ========================================
       KEYBOARD
    ======================================== */

    viewport.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goPrevious();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goNext();
        }
      }
    );

    /* ========================================
       MOBILE SWIPE
    ======================================== */

    viewport.addEventListener(
      'touchstart',
      (event) => {
        if (
          !event.touches ||
          event.touches.length !== 1
        ) {
          return;
        }

        isTouching = true;

        startX =
          event.touches[0].clientX;

        startY =
          event.touches[0].clientY;
      },
      {
        passive: true
      }
    );

    viewport.addEventListener(
      'touchend',
      (event) => {
        if (
          !isTouching ||
          !event.changedTouches ||
          !event.changedTouches.length
        ) {
          return;
        }

        const endX =
          event.changedTouches[0].clientX;

        const endY =
          event.changedTouches[0].clientY;

        const deltaX =
          endX - startX;

        const deltaY =
          endY - startY;

        /*
          横方向へのスワイプが40px以上、
          かつ縦方向より横方向が大きい場合だけ切り替え
        */
        if (
          Math.abs(deltaX) > 40 &&
          Math.abs(deltaX) >
            Math.abs(deltaY)
        ) {
          if (deltaX > 0) {
            goPrevious();
          } else {
            goNext();
          }
        }

        isTouching = false;
      },
      {
        passive: true
      }
    );

    update();
  }

  /* ========================================
     INITIALIZE ALL
  ======================================== */

  function initAllStoryCarousels(scope = document) {
    const sections =
      scope.querySelectorAll(
        '.story-image-section'
      );

    sections.forEach((section) => {
      initStoryCarousel(section);
    });
  }

  /* 通常ロード */
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllStoryCarousels();
      }
    );
  } else {
    initAllStoryCarousels();
  }

  /* ========================================
     SHOPIFY THEME EDITOR
  ======================================== */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const section =
        event.target.querySelector(
          '.story-image-section'
        ) ||
        (
          event.target.classList &&
          event.target.classList.contains(
            'story-image-section'
          )
            ? event.target
            : null
        );

      if (!section) return;

      section.dataset.carouselInitialized =
        'false';

      initStoryCarousel(section);
    }
  );
})();